import {
  IThemeColor,
  IThemeEssentialColor,
  IThemeMarkerColor,
} from "../theme.types";

const Alerts: IThemeColor = {
  primary: "#c32b2a",
  secondary: "#eb871b",
  tertiary: "#ffc425",
  quaternary: "#fbe6b5",
  quinary: undefined,
  senary: undefined,
  septenary: undefined,
  octonary: "#0179C0",
};

const Brand: IThemeColor = {
  primary: "#0079c1",
  secondary: "#2f97d6",
  tertiary: "#6ab7e4",
  quaternary: "#c5e5f0",
  quinary: "#dcf6ff",
  senary: undefined,
  septenary: undefined,
};

const CTA: IThemeColor = {
  primary: "#639d36",
  secondary: "#7dca42",
  tertiary: "#9ed872",
  quaternary: "#c7e6af",
  quinary: "#caf1ca",
  senary: "#e4fee4",
  septenary: undefined,
};

const Grays: IThemeColor = {
  primary: "#929292",
  secondary: "#b3b3b3",
  tertiary: "#cecece",
  quaternary: "#f6f6f6",
  quinary: "#000000",
  senary: "#e5e5e5",
  septenary: "#666666",
};

const Essential: IThemeEssentialColor = {
  black: "#000000",
  grayDark: "#666666",
  grayLight: "#f6f6f6",
  white: "#ffffff",
  buttonGreen: "#4d6e33",
};

const MapMarkers: IThemeMarkerColor = {
  extendedRepairFill: "#ffd1d1",
  extendedRepairStroke: "#c22b2a",
  nonCEFill: "#929292",
  nonCEStroke: "#929292",
};

export default {
  Alerts,
  Brand,
  CTA,
  Grays,
  Essential,
  MapMarkers,
};
